module.exports = __webpack_public_path__ + "img/b6-4.ab94a8e.png";